export function updateProgressBar(mainProcessTypeIdAsString: string) {
    let mainProcessTypeId = Number.parseInt(mainProcessTypeIdAsString);
    let progressBarWrapper = $('#progress');

    if (progressBarWrapper.length > 0 && mainProcessTypeId > 0) {
        progressBarWrapper.load(
            window.ETDR_RD.appConfig['UrlAction.UpdateProgressBar'],
            {
                processId: 0,
                mainProcessTypeId: mainProcessTypeId
            }
        );
    }
}
